module.exports = __webpack_public_path__ + "static/media/Quesadillas enchiladas.07c3fb3c.webp";